import { render, staticRenderFns } from "./EmployeeFundWalletConfirmation.vue?vue&type=template&id=1d244a99"
import script from "./EmployeeFundWalletConfirmation.vue?vue&type=script&lang=js"
export * from "./EmployeeFundWalletConfirmation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeFundWalletConfirmation.vue?vue&type=style&index=0&id=1d244a99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports